<template>
  <div class="login-box">
    <div class="fullScreen" @click="fullscreen">
      <i :class="isFullscreen? 'iconfont icon-tuichuquanping':'iconfont icon-ln_quanping'"></i>
    </div>
    <div class="login-form">
      <div class="login-header">
        <div class="english">WELCOME</div>
        <div class="text-title">新兴火龙果管理平台</div>
      </div>
      <el-form>
        <el-form-item>
          <div class="lable">账号:</div>
          <div class="input-icon">
            <img class="img-icon" :src="accountUrl" alt />
            <input type="text" class="input" v-model="from.username" v-on:input="usernameEvent" />
            <img class="state-img" src="../../assets/login/true.png" alt />
          </div>
        </el-form-item>
        <el-form-item>
          <div class="lable">密码:</div>
          <div class="input-icon">
            <img class="img-icon" :src="passwordUrl" alt />
            <input type="password" class="input" v-model="from.password" v-on:input="passwordEvent" />
            <img class="state-img" src="../../assets/login/true.png" alt />
          </div>
        </el-form-item>
        <el-form-item>
          <div class="lable">验证码:</div>
          <div class="code">
            <div class="code-box">
              <img class="img-icon" :src="codeUrl" alt />
              <input type="text" class="input-code" v-model="from.code" v-on:input="codeEvent" />
              <img class="state-img" src="../../assets/login/true.png" alt />
            </div>
            <div class="text-code">
              <img src alt />
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div class="login-btn">
        <div class="forget-password" @click="forgetPassword">忘记密码？</div>
        <div class="btn" @click="login">登录</div>
      </div>
    </div>
  </div>
</template>
<script>
import account from "../../assets/login/accountFocus1.png";
import accountFocus from "../../assets/login/account1.png";
import password from "../../assets/login/password.png";
import passwordFocus from "../../assets/login/passwordFocus.png";
import codeFocus from "../../assets/login/codeFocus.png";
import code from "../../assets/login/code.png";
import screenfull from "screenfull";
export default {
  data() {
    return {
      accountUrl: account,
      passwordUrl: password,
      codeUrl: code,
      from: {
        username: "",
        password: "",
        code: ""
      },
      isFullscreen: false
    };
  },
  created() {
    let that = this;
    window.onresize = function() {
      if (screenfull.isFullscreen) {
        that.isFullscreen = true;
      } else {
        that.isFullscreen = false;
      }
    };
  },
  methods: {
    fullscreen() {
      screenfull.toggle();
      this.isFullscreen = true;
    },
    usernameEvent() {
      if (this.from.username.length != 0) {
        this.accountUrl = accountFocus;
      } else {
        this.accountUrl = account;
      }
    },
    passwordEvent() {
      if (this.from.password.length != 0) {
        this.passwordUrl = passwordFocus;
      } else {
        this.passwordUrl = password;
      }
    },
    forgetPassword() {
      this.$router.push({
        path: "/forgetpass"
      });
    },
    codeEvent() {
      if (this.from.code.length != 0) {
        this.codeUrl = codeFocus;
      } else {
        this.codeUrl = code;
      }
    },
    login() {
      if (this.from.username && this.from.password && this.from.code) {
        console.log("登录");
      } else if (!this.from.username) {
        this.$message({
          message: "请输入用户名",
          type: "warning"
        });
      } else if (!this.from.password) {
        this.$message({
          message: "请输入密码",
          type: "warning"
        });
      } else if (!this.from.code) {
        this.$message({
          message: "请输入验证码",
          type: "warning"
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.login-box {
  width: 100%;
  height: 100%;
  background: url("../../assets/login/bg.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
  .fullScreen {
    position: absolute;
    right: 40px;
    top: 20px;
    i {
      font-size: 30px;
      color: #9ad2b6;
    }
  }
  .login-form {
    width: 700px;
    padding: 80px 88px 0 90px;
    box-sizing: border-box;
    position: absolute;
    top: 70px;
    left: 1120px;
    .login-header {
      padding-top: 10px;
      .english {
        font-size: 32px;
        font-family: Tahoma;
        font-weight: 400;
        color: #141414;
        line-height: 51px;
      }
      .text-title {
        font-size: 42px;
        font-family: HuXiaoBo-NanShen;
        font-weight: 700;
        color: #141414;
        line-height: 51px;
      }
    }
    .el-form {
      margin-top: 44px;
      .lable {
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #131313;
        line-height: 50px;
        padding-left: 10px;
        // margin-bottom: 10px;
      }

      .input-icon {
        height: 40px;
        width: 100%;
        border-bottom: 1px solid rgba(153, 153, 153, 1);
        position: relative;

        .input {
          width: 91%;
          outline: none;
          border: 0px;
          background: transparent;
          line-height: 40px;
          font-size: 18px;
          padding-left: 15px;
          box-sizing: border-box;
        }
        .state-img {
          position: absolute;
          right: 0px;
        }
      }
      .img-icon {
        padding-left: 10px;
      }
      .code {
        height: 40px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        .code-box {
          width: 70%;
          display: flex;
          align-items: center;
          border-bottom: 1px solid rgba(153, 153, 153, 1);
        }
        .input-code {
          width: 100%;
          outline: none;
          border: 0px;
          background: transparent;
          line-height: 40px;
          font-size: 18px;
          padding-left: 15px;
          box-sizing: border-box;
        }
        img {
          width: 18px;
          height: 21px;
        }
        .text-code {
          width: 142px;
          height: 40px;
          background: #cf9c9c;
          letter-spacing: 15px;
          font-size: 20px;
          text-align: center;
        }
      }
      .el-form-item {
        margin-bottom: 30px;
      }
    }
  }
  .login-btn {
    margin-top: 40px;
    .forget-password {
      cursor: pointer;
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #0fc369;
      line-height: 40px;
    }
    .btn {
      cursor: pointer;
      width: 520px;
      height: 50px;
      background-color: #10c469;
      text-align: center;
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ffffff;
      line-height: 50px;
      box-shadow: 9px 6px 16px #d4f4e4;
    }
  }
}
</style>